export default (Alpine) => {
    Alpine.data("heroVideo", () => ({
      init() {
        const video = this.$refs.video;
        if (!video || !this.$refs.previewImage || !this.$refs.endImage) return;
  
        video.addEventListener('timeupdate', () => {
          if (video.duration && video.currentTime >= video.duration - 0.08) {
            video.pause();
            video.currentTime = video.duration - 0.08;
  
            this.swapToEndImage();
          }
        });
      },
  
      swapToEndImage() {
        this.$refs.previewImage.classList.add('hidden');
        this.$refs.video.classList.add('invisible');
        this.$refs.endImage.classList.remove('invisible');
      }
    }));
  };
  